module.exports = __webpack_public_path__ + "img/preloader-center.4017ee90.svg";